import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
import utils from "./models/utils";
import global from "./models/global";

export default new Vuex.Store({
  modules: {
    utils,
    global,
  },
  plugins: [createPersistedState()], // 使用 vuex-persistedstate 插件
});
